import { render, staticRenderFns } from "./ClientsCreateDoc.vue?vue&type=template&id=0fb8a78c"
import script from "./ClientsCreateDoc.vue?vue&type=script&lang=js"
export * from "./ClientsCreateDoc.vue?vue&type=script&lang=js"
import style0 from "./ClientsCreateDoc.vue?vue&type=style&index=0&id=0fb8a78c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports